<template>
  <component :is="mainComponent" />
</template>

<script setup lang="ts">
import { computed, ComputedRef, inject, watch } from 'vue'
import { useRouter } from 'vue-router'

import { ADVISOR_MODE, ROUTE_NAME } from '@/const'

import { useResponsive } from '@/plugins/responsiveUI'

import AdvisorMobile from './Advisor/AdvisorMobile.vue'
import AdvisorDesktop from './Advisor/AdvisorDesktop.vue'

defineOptions({ name: 'AdvisorLayout' })

const { isMobile, isTablet } = useResponsive()
const router = useRouter()

const isAdvisorMode = inject<ComputedRef<boolean>>(ADVISOR_MODE)

const mainComponent = computed(() =>
  isMobile.value || isTablet.value ? AdvisorMobile : AdvisorDesktop,
)

watch(() => isAdvisorMode?.value, value => {
  if (value) return
  router.push({ name: ROUTE_NAME.DASHBOARDS })
}, {
  immediate: true,
})
</script>
